import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../../../generic/Icon';
import RouterLink from '../../../generic/Link/RouterLink';
import PageHeadingBreadcrumbs from '../../../generic/PageHeadingBreadcrumbs';

import styles from './FossabotImportHeader.module.less';

/** Where Back returns to: the quick import service picker. */
const QUICK_IMPORT_URL = '/projects/import/cloud';

/*
 * Neither crumb links anywhere: Back already covers the only way out, so the crumbs are
 * `content` rather than `text`, which also keeps them off `Crumb`'s white-on-black colour.
 */
const CRUMBS = [
  { content: 'Quick import' },
  { content: 'fossabot app' },
];

/**
 * The page's own header, standing in for the legacy import Subnav: a Back link out to the
 * service picker, then the breadcrumb naming where the user has landed.
 */
export const FossabotImportHeader: VoidFunctionComponent = () => (
  <header className={styles.header}>
    <div className="container container-responsive">
      <RouterLink to={QUICK_IMPORT_URL} className={styles.back}>
        <span className={styles.backIcon}><Icon icon={icons.angleLeft} /></span>
        Back
      </RouterLink>
      <div className={styles.crumbs}>
        <PageHeadingBreadcrumbs
          crumbs={CRUMBS}
          separator={<Icon icon={icons.angleRight} />}
        />
      </div>
    </div>
  </header>
);
